import Popover from './Popover';
import * as positions from './Positions';

export default Popover;
export const Positions = positions;



// WEBPACK FOOTER //
// ./../src/Popover/index.js